import { render, staticRenderFns } from "./PopUpDataTableWithSearch.vue?vue&type=template&id=e668adf0"
import script from "./PopUpDataTableWithSearch.vue?vue&type=script&lang=js"
export * from "./PopUpDataTableWithSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports